// extracted by mini-css-extract-plugin
var _1 = "cardSection__CvAgT";
var _2 = "detailRow__WPx1S";
var _3 = "header__FFdoC";
var _4 = "monthlyPayment__AWLI8";
var _5 = "planCard__Gx3rA";
var _6 = "planRow__MZ2CQ";
var _7 = "screen__PxjbT";
export { _1 as "cardSection", _2 as "detailRow", _3 as "header", _4 as "monthlyPayment", _5 as "planCard", _6 as "planRow", _7 as "screen" }
